import { Typography } from "@eisox/design-system";
import { useNavigate } from "@tanstack/react-router";

import * as ErrorCollapsibleComponent from "~/components/error-collapsible";
import type { AirHandlerUnitError } from "~/types/air-handler-unit.type";

const NAME = "ErrorCollapsible";

interface ErrorCollapsibleProps extends ErrorCollapsibleComponent.ErrorCollapsibleProps {
  buildingId: string;
  errors: AirHandlerUnitError[];
}

const ErrorCollapsible: React.FC<ErrorCollapsibleProps> = ({ buildingId, errors, className, ...props }) => {
  const navigate = useNavigate();

  return (
    <ErrorCollapsibleComponent.Root {...props} className={className}>
      {errors.map((error, index) => (
        <ErrorCollapsibleComponent.ErrorItem key={index} asChild>
          <Typography
            onClick={() => {
              void navigate({
                to: "/buildings/$buildingId/air-handler-units/$airHandlerUnitId",
                params: { buildingId, airHandlerUnitId: error.airHandlerUnitId },
              });
            }}
          >
            {`${error.airHandlerUnitName}: ${error.message}`}
          </Typography>
        </ErrorCollapsibleComponent.ErrorItem>
      ))}
    </ErrorCollapsibleComponent.Root>
  );
};

ErrorCollapsible.displayName = NAME;

export { ErrorCollapsible };
